import { Store } from 'store/index';
import getDesignedProduct from './getDesignedProduct';

const getDesignProductSizeGuideImage = (store: Store) => {
  const product = getDesignedProduct(store);
  return product?.content?.productSideDescriptionImage || undefined;
};

export default getDesignProductSizeGuideImage;
